import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useDashboardKPIs = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)

  const fetchData = useCallback(async () => {
    setLoading(true)

    try {
      const { data } = await RequestService.getDashboardKPIs()

      setData(data)
    } catch (e) {
      console.log('useDashboardKPIs', e)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return { loading, data }
}

export default useDashboardKPIs
